<template>
    <div class="train">
        <h1>竞赛培训指导</h1>
        
        <div class="section" v-for="(content, index) in sections" :key="index" style="white-space: break-spaces;">
            <h2>{{ content.title }}</h2>
            <p v-if="content.body" style="text-align: justify;">&emsp;&emsp;{{ content.body }}</p>
        </div>
        
        <!-- Optional: Include images or illustrations related to the laboratory -->
        
        <div class="section" v-if="hasImages">
            <h2>图片</h2>
            <div class="flex-container">
                <div class="flex-item" v-for="(image, index) in images" :key="index">
                    <img v-loading="{ minHeight: '50px', minWidth: '50px', size: '25px' }" :src="require('../assets/images/Train/' + image.src)" :alt="image.alt">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        sections: [
            {
                title: '🔧 课程服务',
                body: '我们提供涵盖基础建模、机械结构、电子电路、人工智能、可持续设计等方向的系统课程，支持学校建设创新实验室、科技社团、项目式学习课程和特色选修课，帮助学生夯实科学与工程基础，激发实践创造力。',
            },
            {
                title: '🏁 国际竞赛服务',
                body: '我们是多个国际知名赛事的合作方与认证机构，为学生提供从入门到精英级别的竞赛支持，包括：\n  ① 3D建模与仿真设计: 从基础建模到空气动力学与结构仿真，培养数字化设计与工程创新能力。\n  ② 机械结构与工程系统：学习机械原理与应用，探索机器人、车辆与复杂装置的结构设计。\n  ③ 电子电路与智能控制：从传感器与电机控制到智能原型开发，掌握未来科技的核心技能。\n  ④ 人工智能与编程：从图形化编程到Python与AI应用，提升算法思维与数据处理能力。\n  ⑤ 商业与创新展示：融合商业计划、品牌建设与国际化展示，培养全球化沟通与表达力。',
            },
            {
                title: '🌍 定制化服务',
                body: '提供短期集训与长期培养方案\n  针对不同赛事规则设计课程路径\n  导师制辅导 + 国际赛事资源对接\n  支持学校课程嵌入与团队整体培训',
            },
            {
                title: '我们的愿景:',
                body: '通过整合全球教育资源、先进技术与本地化实践经验，圣七教育致力于成为连接未来教育与现实场景的桥梁，帮助每一位学生在探索中成长，在创造中突破。'
            }
        ],
        // Images array can be added here if available
        images: [
            { src: "1.jpg", alt: 'WRO选手训练基地' },
            { src: "2.jpg", alt: '赛事培训剪影1' },
            { src: "3.jpg", alt: '赛事培训剪影2' },
            { src: "4.jpg", alt: '赛事培训剪影3' },
        ],
        hasImages: true, // Set to true if images array is defined
        };
    },
};
</script>

<style scoped>
/* Add basic styling for readability */
.train {
    padding: 6vw;
    font-family: 'FangYuan';
    color: #513890;
    font-size: 1rem;
    font-weight: normal;
    letter-spacing: 0.16em;
    line-height: 2em;
}

body {
line-height: 1.6;
margin: 0;
padding: 0;
}

h1 {
text-align: center;
margin-top: 3rem;
}

.section {
margin-bottom: 2rem;
}

h2 {
margin-top: 2rem;
}

ul {
display: flex;
list-style-type: disc;
margin-left: 1.5rem;
margin-bottom: 1rem;
}

ul li{
display: inline;
flex: 1;
text-align: left;
}

p {
margin-bottom: 1rem;
}

.highlight {
font-weight: bold;
}

.flex-container {
display: flex;
flex-wrap: wrap;
justify-content: space-between;
margin-top: 1rem;
}

.flex-item {
flex-basis: calc(50% - 1rem);
margin-bottom: 1rem;
}

img {
max-width: 100%;
height: auto;
}

@media screen and (max-width: 768px) {
    .flex-item {
        flex-basis: 100%;
    }
}
</style>